import React, { createContext, useCallback, useMemo, useState } from 'react';
import { node, shape } from 'prop-types';

export const DrawerContext = createContext({
  componentProps: {},
  ref: null,
  setDrawerComponentProps: () => {},
});

const DrawerContextStore = ({ children, container }) => {
  const [componentProps, setDrawerComponentProps] = useState({
    Component: '',
    drawerPaperSx: undefined,
    forceCloseSelector: () => false,
    handleContinue: undefined,
    holdOpenSelector: () => false,
    refreshNotifications: false,
    resetWizard: undefined,
    setCurrentDialogOpen: () => {},
    type: '',
  });

  const setDrawerComponent = useCallback(
    props => {
      setDrawerComponentProps({ ...componentProps, ...props });
    },
    [componentProps]
  );

  const contextValue = useMemo(
    () => ({
      componentProps,
      ref: container,
      setDrawerComponentProps: setDrawerComponent,
    }),
    [componentProps, container, setDrawerComponent]
  );

  return <DrawerContext.Provider value={contextValue}>{children}</DrawerContext.Provider>;
};

export default DrawerContextStore;

DrawerContextStore.propTypes = {
  children: node.isRequired,
  container: shape({}).isRequired,
};
